(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.querySelectorAll('[data-nav] a').forEach(function (a) {
      a.addEventListener('click', function () { document.body.classList.remove('nav-open'); });
    });
  }
  var rec = document.querySelector('[data-toggle-recover]');
  if (rec) {
    rec.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById('recover').classList.toggle('is-open');
    });
  }
  // Scroll naar formulier na verzenden
  if (window.location.search.indexOf('contact_posted=true') > -1 || document.querySelector('.notice--success, .notice--error')) {
    var f = document.getElementById('QuoteForm');
    if (f) f.scrollIntoView({ block: 'center' });
  }
})();
